<template>
  <span>
    <span
      v-if="!loadingCharges && !loadingSetting"
      class="message"
      style="float:left;position:relative;border-radius: 12px;max-width: 300px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
    >
      <div style="font-size: 12px;" :style="{'color': 'black'}">
        <div style="padding: 5px 8px 6px;" :style="{'background-color': '#F1F0F0'}">
          <span style="line-height:15.36px;">
            <template>
              === {{$t('Order Summary2')}} ===
              <br />
              <br />
              <div v-for="(it, k) in item.product" :key="k">
                <div v-if="item.option[k]">
                  {{it.name}} ({{items[k].option}})
                  <span>x{{items[k].qty}}</span>
                  : {{parseFloat(item.option[k][3]) * parseFloat(items[k].qty)}} {{$t('Baht')}}
                </div>
                <div v-else>{{$t('please reselect the stock by clicking the edit button')}}</div>
              </div>

              <br />-----------------------------
              <br />
              <div v-if="item.option.every(el=> el)">
                💰{{$t('Total (not including shipping)')}}
                <span
                  v-if="item.option.every(el=> el[3])"
                >{{total}} {{$t('Baht')}}</span>
                <span
                  v-else
                >{{item.product.map(el=>(el.discountprice?parseFloat(el.discountprice) :parseFloat(el.price))).reduce((total, num)=>total+num)}} {{$t('Baht')}}</span>
              </div>
              <br />-----------------------------
              <br />
            </template>
            {{$t('Shipping option')}}
            <br />
            <template v-for="(charge,cindex) in charges">
              <div v-if="charge[1]" :key="cindex">
                📦{{$t(cindex)}}
                <template
                  v-if="charge[0] > 0"
                >+{{charge[0] | decimalFormat}} {{$t('Baht')}}</template>
                <template v-else>{{$t('Free')}}</template>
              </div>
            </template>
          </span>
        </div>
      </div>
      <div
        style="float:left;width: 100%;border: 1px solid #eee; border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;overflow: hidden"
      >
        <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
          <li
            class="list-group-item"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px"
          >
            <span style="color: #0084FF" v-if="currentLang == 'th'">สั่งเพิ่ม/แก้ไข</span>
            <span style="color: #0084FF" v-else-if="currentLang == 'la'">ສັ່ງເພີ້ມ/ແກ້ໄຂ</span>
            <span style="color: #0084FF" v-else>Add More/Edit</span>
          </li>
          <li
            class="list-group-item"
            v-if="showTransfer"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px;border-top:1px solid #eee;"
          >
            <span style="color: #0084FF" v-if="currentLang == 'th'">ชำระเงิน</span>
            <span style="color: #0084FF" v-else-if="currentLang == 'la'">ຊຳລະເງີນ</span>
            <span style="color: #0084FF" v-else>Payments</span>
          </li>
          <li
            class="list-group-item"
            v-if="showCreditcard"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px;border-top:1px solid #eee;"
          >
            <span style="color: #0084FF" v-if="currentLang == 'th'">บัตรเครดิต</span>
            <span style="color: #0084FF" v-else-if="currentLang == 'la'">ບັດເຄດິດ</span>
            <span style="color: #0084FF" v-else>Credit Card</span>
          </li>
        </ul>
      </div>
    </span>
    <span class="clearfix"></span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      selectedProducts: [],
    }
  },
  props: {
    items: {
      type: Array,
    },
  },
  computed: {
    total() {
      var vm = this
      var result = this.item.option.map((el) => {
        return parseFloat(el[3])
      })
      var sum = 0
      result.forEach((el, index) => {
        sum += parseFloat(el) * parseFloat(this.items[index].qty)
      })
      return sum
    },
    ...mapGetters({
      setting: 'setting',
      loadingSetting: 'getLoadingSetting',
      currentLang: 'currentLang',
      loadingCharges: 'getLoadingCharges',
      charges: 'getCharges',
      products: 'getProducts',
    }),
    showTransfer: function () {
      return this.loadingSetting
        ? false
        : this.setting['allowtransfer'] && this.setting['allowtransfer'].contentvalue
    },
    showCreditcard: function () {
      return this.loadingSetting
        ? false
        : this.setting['allowcreditcard'] && this.setting['allowcreditcard'].contentvalue
    },
    item() {
      var selectedProduct = this.items.map((el) => {
        return this.products.find((val) => {
          return val.id.toString().includes(el.pid)
        })
      })

      return {
        product: selectedProduct,
        option: selectedProduct
          .map((el) => {
            if (el) {
              return el.productstock.filter((val) =>
                this.items.map((el) => el.option).includes(val[1])
              )
            } else return null
          })
          .map((el) => {
            if (el) return el[0]
            else return null
          }),
        // option: this.products
        //   .filter(el => el.id == this.items.pid)[0]
        //   .productstock.filter(el => el[1] == this.items.option)[0]
      }
    },
  },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/ViewCartSummaryViewer2.vue